<fieldset [disabled]="disabled$ | async">
  @if (disabled === false) {
    <div
      class="context-switcher"
      #dropdown="tippy"
      [popover]="true"
      [portalTippy]="content"
      [trigger]="manualTrigger ? 'manual' : 'click'"
      [triggerTarget]="manualTrigger ? undefined : trigger"
      (openChange)="dropdownOpenChanged($event)"
      appendTo="body"
      placement="bottom-start"
    >
      <div class="context-switcher__trigger" #trigger>
        @if (selectedValue?.value != null) {
          @if (triggerTemplate == null) {
            <button class="context-switcher__toggle btn btn--portal-link" type="button">
              <ng-container
                *ngTemplateOutlet="
                  labelTemplate !== undefined ? labelTemplate : label;
                  context: { $implicit: selectedValue }
                "
              ></ng-container>
              @if (hideArrow === false) {
                <i class="far fa-angle-down ms-1"></i>
              }
            </button>
          } @else {
            <ng-container
              [ngTemplateOutlet]="triggerTemplate"
              [ngTemplateOutletContext]="{ $implicit: selectedValue }"
            ></ng-container>
          }
        }
      </div>
      @if (allowPreviousNext) {
        <div class="btn-group context-switcher__actions">
          <button class="btn btn-icon btn-sm py-0 border-0" (click)="triggerPrevious()">
            <i class="far fa-chevron-left"></i>
          </button>
          <button class="btn btn-icon btn-sm py-0 border-0" (click)="triggerNext()">
            <i class="far fa-chevron-right"></i>
          </button>
        </div>
      }
    </div>
  } @else {
    <portal-link [route]="initialRoute">
      <ng-container
        *ngTemplateOutlet="
          labelTemplate !== undefined ? labelTemplate : label;
          context: { $implicit: selectedValue }
        "
      ></ng-container>
    </portal-link>
  }
</fieldset>

<ng-template #content>
  <div class="context-switcher__dropdown">
    <div class="dropdown-header">
      <input
        class="form-control"
        #input
        [placeholder]="placeholder"
        (input)="onSearchInput($event.target)"
        (keydown)="onKeyDown($event)"
        autocomplete="off"
        type="text"
      />
    </div>

    @for (entry of filteredEntries; track entry; let index = $index) {
      <ng-container
        [ngTemplateOutlet]="isString(entry.meta?.skip) ? withTooltip : dropdownItem"
      ></ng-container>
      <ng-template #withTooltip>
        <!-- .toString() is only because angular cannot know that skip can only be a string in this case (it is checked by the above ng-container) -->
        <div [portalTippy]="entry.meta.skip.toString() | translate" appendTo="body" placement="right">
          <ng-container [ngTemplateOutlet]="dropdownItem"></ng-container>
        </div>
      </ng-template>
      <ng-template #dropdownItem>
        <div
          class="dropdown-item"
          [ngClass]="{
            disabled: entry.meta?.skip != null,
            'dropdown-item--highlight': index === highlightedIndex,
            'dropdown-item--selected': index === selectedIndex,
          }"
          (click)="emit(entry)"
        >
          <ng-container
            [ngTemplateOutlet]="dropdownItemTemplate || defaultItemTemplate"
            [ngTemplateOutletContext]="{ entry, term }"
          ></ng-container>
          <ng-template #defaultItemTemplate>
            <span [innerHTML]="entry.label | highlightText: term"></span>
            @if (entry.meta?.warn != null) {
              <span
                ><i
                  class="far fa-exclamation-circle ms-2"
                  [portalTippy]="entry.meta.warn.toString() | translate"
                  appendTo="body"
                  placement="right"
                ></i
              ></span>
            }
          </ng-template>
        </div>
      </ng-template>
    }

    @if (entries != null) {
      <div class="dropdown-footer">
        @if (filteredEntries.length < entries.length) {
          {{
            'menu.context.footer.filtered'
              | portalTranslate: { filtered: filteredEntries.length, total: entries.length }
          }}
        }
        @if (filteredEntries.length === entries.length) {
          {{ 'menu.context.footer.total' | portalTranslate: { total: entries.length } }}
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #label let-typeahead>
  <span class="context-switcher__label" [innerHTML]="typeahead?.label"></span>
</ng-template>
